import type { IntlShape } from 'react-intl';

const ranges = [
    {
        values: { lowerCcm: '-Infinity', higherCcm: '50', ccm: '50' },
        value: '<50',
        id: 'less than {ccm} ccm',
    },
    { values: { lowerCcm: '51', higherCcm: '125' }, value: '51-125' },
    { values: { lowerCcm: '126', higherCcm: '250' }, value: '126-250' },
    { values: { lowerCcm: '251', higherCcm: '500' }, value: '251-500' },
    { values: { lowerCcm: '501', higherCcm: '750' }, value: '501-750' },
    { values: { lowerCcm: '751', higherCcm: '1000' }, value: '751-1000' },
    { values: { lowerCcm: '1001', higherCcm: '1250' }, value: '1001-1250' },
    { values: { lowerCcm: '1251', higherCcm: '1500' }, value: '1251-1500' },
    {
        values: { lowerCcm: '1501', higherCcm: 'Infinity', ccm: '1500' },
        value: '1500>',
        id: 'more than {ccm} ccm',
    },
];

export const getCcmFilterValues = (
    intl: IntlShape,
    start: number,
    end: number
) => {
    if (start === 0 && end === 0) return [];

    const getCcmFilterValue = (
        values: Record<string, string | undefined>,
        value: string,
        id = '{lowerCcm} to {higherCcm} ccm'
    ) => ({
        label: intl.formatMessage(
            {
                id,
            },
            values
        ),
        value,
    });

    const filteredRanges = ranges.filter(range => {
        const lowerCcm = Number(range.values.lowerCcm);
        const higherCcm = Number(range.values.higherCcm);

        return start <= higherCcm && end >= lowerCcm;
    });

    return filteredRanges.map(({ values, value, id }) =>
        getCcmFilterValue(values, value, id)
    );
};

export const ccmValuesFromRange = (
    range?: string
): { ccmRangeStart?: number; ccmRangeEnd?: number } => {
    if (!range) {
        return {};
    }

    if (range === '<50') {
        return {
            ccmRangeEnd: 50,
        };
    }

    if (range === '1500>') {
        return {
            ccmRangeStart: 1501,
        };
    }

    const [ccmRangeStart, ccmRangeEnd] = range.split('-').map(Number);

    return {
        ccmRangeStart,
        ccmRangeEnd,
    };
};
